var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConfirmed(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.5C2 12.6217 2.84285 14.6566 4.34315 16.1569C5.84344 17.6571 7.87827 18.5 10 18.5C12.1217 18.5 14.1566 17.6571 15.6569 16.1569C17.1571 14.6566 18 12.6217 18 10.5C18 8.37827 17.1571 6.34344 15.6569 4.84315C14.1566 3.34285 12.1217 2.5 10 2.5C7.87827 2.5 5.84344 3.34285 4.34315 4.84315C2.84285 6.34344 2 8.37827 2 10.5ZM13.6989 7.93117C14.013 8.20114 14.0489 8.67466 13.7789 8.98881L10.3419 12.9884C10.2495 13.0959 10.1333 13.1709 10.0077 13.2121C9.72768 13.3048 9.40702 13.2264 9.20283 12.9888L7.43117 10.9271C7.16121 10.613 7.19703 10.1395 7.51119 9.8695C7.82534 9.59954 8.29886 9.63536 8.56883 9.94952L9.77221 11.3499L12.6413 8.01119C12.9112 7.69703 13.3847 7.66121 13.6989 7.93117Z",
    fill: "#10B07C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/confirmed.ab28c496.svg";
export { ForwardRef as ReactComponent };